export const quickSearch = {
    state: {
        status: 'idle',
        quickSearch: []
    },
    mutations: {
        SET_QUICKSEARCH_STATUS(state, status) {
            state.status = status
        },
        SET_QUICKSEARCH(state, quickSearch) {
            state.quickSearch = quickSearch
        },
        RESET_QUICKSEARCH(state) {
            state.quickSearch = []
        }
    },
    actions: {
        fetchQuickSearch({ state, commit }, payload) {
            let params = ''
            if(payload.params) {
                params = `&${Object.entries(payload.params)
                    .filter(([key, value]) => value !== '')
                    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                    .join('&')}`
            }
            commit('SET_QUICKSEARCH_STATUS', 'loading')
            commit('RESET_QUICKSEARCH')
            const type = () => {
                if (payload.object === 'none') {
                    return ''
                }

                return payload.object ? '/list' : '/search'
            }
            const selectedType = type()

            if (selectedType === '') {
                return this.$api.get(`api/${payload.name}.json?${params}`).then((response) => {
                    commit('SET_QUICKSEARCH', response.data.data)
                    commit('SET_QUICKSEARCH_STATUS', 'idle')
                }).catch(error => {
                    commit('SET_QUICKSEARCH_STATUS', 'error')
                    return Promise.reject(error)
                })
            }
            return this.$api.get(`api/${payload.name}${type()}.json?q=${payload.query ?? ''}${params}`).then((response) => {
                commit('SET_QUICKSEARCH', response.data.data)
                commit('SET_QUICKSEARCH_STATUS', 'idle')
            }).catch(error => {
                commit('SET_QUICKSEARCH_STATUS', 'error')
                return Promise.reject(error)
            })
        }
    },
    getters: {
        quickSearchStatus: (state) => {
            return state.status
        },
        quickSearch: (state) => {
            if(state.quickSearch) {
                return state.quickSearch
            }
        }
    }
}
